import Vue from 'vue'

/**
 * 两数相乘，解决js乘法浮点错误
 */
const multiply = function (a, b) {
    var m = 0, _a = String(a), _b = String(b);
    if (_a.indexOf(".") > -1) {
        m += _a.split(".")[1].length;
    }
    if (_b.indexOf(".") > -1) {
        m += _b.split(".")[1].length;
    }
    return Number(_a.replace(".", "")) * Number(_b.replace(".", "")) / Math.pow(10, m);
}

const round = function (val, b) {
    var p = Math.pow(10, b);
    if (val < 0) {
        return -1 * Math.round(multiply(Math.abs(val), p)) / p;
    } else {
        return Math.round(multiply(val, p)) / p;
    }
}

Vue.prototype.$number = {
    multiply,
    round
}